import { jsx as o } from "react/jsx-runtime";
import { IconContainer as a } from "../IconContainer.js";
import { D as c } from "../DuplicateIcon-a73a111a.js";
import { Button as f } from "antd";
import { memo as p } from "react";
const x = p(function({
  handleClick: t,
  disabled: r = !1,
  style: n,
  Icon: m = c,
  type: i = "primary",
  size: e = 19
}) {
  return /* @__PURE__ */ o(f, { type: i, disabled: r, onClick: t, style: n, children: /* @__PURE__ */ o(a, { size: e, children: /* @__PURE__ */ o(m, {}) }) });
});
export {
  x as default
};
//# sourceMappingURL=PasteButton.js.map
